import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useGoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const measurementId = import.meta.env?.VITE_GA_MEASUREMENT_ID;

    if (!measurementId || measurementId === 'your-google-analytics-id-here') {
      console.warn('GA4 Measurement ID not configured');
      return;
    }

    // Usar id en el DOM como guardia — sobrevive re-renders, HMR y Strict Mode
    const scriptId = 'ga4-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      script.async = true;
      document.head.appendChild(script);

      // Preservar dataLayer si ya existe (evita reinicializar en remounts)
      window.dataLayer = window.dataLayer || [];
      // Usar function declaration con arguments para compatibilidad con gtag estándar
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', measurementId);
    }

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: location?.pathname + location?.search,
      });
    }
  }, [location]);
}

export default useGoogleAnalytics;
